export default {
  en: "English",
  uk: "Українська",
  ru: "Русский"
}